import * as React from 'react';
import {styled, mq} from '../../../utils';
import {margin, hideVisually} from 'polished';
import Flex from '../../../components/Flex';
import {IconCheck} from '../../../components/SvgIcon';
import {StepStatus, StepTitleRenderFnProps} from '../../../components/Wizard';

const Text = styled('h2')<{status: StepStatus}>(
  ({theme}) => ({
    fontFamily: theme.fontFamily.base,
    fontSize: 24,
    color: '#575C64',
    marginBottom: 25
  }),
  ({theme, status}) => {
    if (status === 'processing') {
      return {
        color: theme.color.primary,
        ...margin(15, 0, 50)
      };
    }
    if (status === 'pending') {
      return {
        color: '#C5CAD4',
        [mq('phone')]: hideVisually(),
        [mq('tablet')]: hideVisually()
      };
    }
    return {};
  }
);

const Separator = styled('hr')({
  color: '#F1F3F6',
  border: '1px solid #F1F3F6',
  marginBottom: 30
});

export default class RegistrationWizardStepTitle extends React.Component<Partial<StepTitleRenderFnProps>, {}> {
  public render() {
    const {title, status} = this.props;
    const finished = 'finished' === status;

    return (
      <React.Fragment>
        <Flex justify="space-between">
          <Text status={status!}>{title}</Text>
          {finished ? <IconCheck color="#08C173" /> : null}
        </Flex>
        {finished ? <Separator /> : null}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/RegistrationWizard/private/RegistrationWizardStepTitle.tsx